import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';

export interface IReviewMetadata {
  score: number;
  author: string;
  platform: string;
  reviewerType?: string;
}
export interface IGenerateCommentOptions {
  language: string;
  tonality: string;
  duzen: boolean;
  review: string;
  useCustomerName: boolean;
  salutation: string;
  signature: string;
  additionalPrompt: string;
  maxCharacters?: number;
  reviewMetadata: IReviewMetadata;
  /** true when the review carried no written text; the backend tells the model so (769719). */
  noReviewText?: boolean;
}

const generateComment = async (
  generateCommentOptions: IGenerateCommentOptions,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.post('/comment-ai/generate', generateCommentOptions);
    loading(false);
    const { message } = data;
    return message;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const CommentAiService = {
  generateComment,
};

export default CommentAiService;
